import autosize from "autosize";

$(document).on("vue-render", autoResizeTextareas).on("DOMContentLoaded", autoResizeTextareas);

$(window).on("resize", autoResizeTextareas);

function autoResizeTextareas() {
  autosize($(".autoresize:not(.lazy)"));
}
